import { useMutation, gql } from '@apollo/client';

export const DELETE_COMPANY_LOCATIONS_BY_IDS = gql`
  mutation deleteLocationById($locationId: ObjectId!) {
    deleteLocationById(locationId: $locationId)
  }
`;

export const useDeleteCompanyLocationById = () => {
  const [deleteCompanyLocationById] = useMutation(DELETE_COMPANY_LOCATIONS_BY_IDS);

  return deleteCompanyLocationById;
};
